import React, { useCallback } from 'react';

function Footer() {

  const navTo = useCallback((url: string) => {
    if (url) {
      window.open(url)
    }
  }, [])

  return (
    <div className=' z-[9999999] fixed w-[100%] h-[44px] bottom-0 left-0 bg-form-bg flex justify-center items-center'>
      <div className=' h-[16px] w-[107.83px] flex justify-between items-center'>
        <img alt='empty' className=' cursor-pointer h-[16px]' src={require('../../../img/Facebook.png')} onClick={() => { navTo('https://www.facebook.com/holidale') }} />
        <img alt='empty' className=' cursor-pointer h-[16px]' src={require('../../../img/Twitter.png')} onClick={() => { navTo('https://twitter.com/Holidale') }} />
        <img alt='empty' className=' cursor-pointer h-[16px]' src={require('../../../img/lin.png')} onClick={() => { navTo('https://www.linkedin.com/company/holidale-inc-/') }} />
        <img alt='empty' className=' cursor-pointer h-[16px]' src={require('../../../img/Inst.png')} onClick={() => { navTo('https://www.instagram.com/month2monthdotcom/') }} />
      </div>
    </div>
  );
}

export default Footer;
